export default __webpack_public_path__ + "static/media/status_title_icon.949a9c3e.svg";